import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Manages the overall data field schema interface
export default class extends Controller {
  static values = {
    resource: String
  }

  connect() {
    logger.log("Data field schema manager connected")
  }

  // Handle flash messages
  showFlash(message, type = 'info') {
    const flashContainer = document.getElementById('flash')
    if (flashContainer) {
      flashContainer.innerHTML = `
        <div class="alert alert-${type} alert-dismissible fade show" role="alert">
          ${message}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      `
      
      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        const alert = flashContainer.querySelector('.alert')
        if (alert) {
          const bsAlert = new bootstrap.Alert(alert)
          bsAlert.close()
        }
      }, 5000)
    }
  }
}


